export default function BumperCarsIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#0E2A55" />
      <circle cx="32" cy="34" r="26" fill="#3B4FA8" stroke="#FFD34D" strokeWidth="3" strokeDasharray="2 4" />
      <g transform="translate(21 37) rotate(-20)">
        <circle r="12" fill="#20232B" />
        <rect x="-9" y="-8" width="18" height="16" rx="6" fill="#2F8BFF" />
        <circle cx="-2" cy="0" r="4" fill="#FFD9B3" />
      </g>
      <g transform="translate(43 30) rotate(160)">
        <circle r="12" fill="#20232B" />
        <rect x="-9" y="-8" width="18" height="16" rx="6" fill="#FF8A1F" />
        <circle cx="-2" cy="0" r="4" fill="#FFD9B3" />
      </g>
      <path d="M32 22 l3 6 l6 1 l-5 4 l2 6 l-6 -3 l-6 3 l2 -6 l-5 -4 l6 -1 z" fill="#FFF27A" stroke="#E0A400" strokeWidth="1" />
      <path d="M12 10 c-3 4 -3 6 0 9 M52 10 c3 4 3 6 0 9" stroke="#FF4F6A" strokeWidth="3" fill="none" strokeLinecap="round" />
    </svg>
  );
}
